import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { HeaderStyled } from "./Header.style";
var Header = function(param) {
    var heading = param.heading, subheading = param.subheading;
    return /*#__PURE__*/ _jsx(HeaderStyled, {
        children: /*#__PURE__*/ _jsxs("span", {
            className: "text",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "heading",
                    children: heading
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "subheading",
                    children: subheading
                })
            ]
        })
    });
};
export default Header;
